<template>
  <div>
    <div v-if="location.loc_pl_schedule.location_id">
      <b-row>
        <b-col style="text-align:center;">
          <b-form-group label="Select days to schedule">
            <b-form-checkbox-group
              v-model="activedays"
              :options="daysofweek"
              name="days-select"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center;">OR</b-col>
      </b-row>
      <b-row class="py-2">
        <!-- <b-col cols="1"><label for="date-schedule">Date</label></b-col> -->
        <b-col cols="6">
          Date
          <b-form-datepicker
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
            reset-button
            close-button
            v-model="schedDate"
          ></b-form-datepicker>
        </b-col>
        <!-- <b-col cols="3" class="mr-0 pr-0"><label for="recurring-schedule">Recurring days</label></b-col> -->
        <b-col cols="6" class="m-0 p-0">Recurring days<b-form-input id="recurring-schedule" style="float:right;" v-model="recurringDays" type="number"></b-form-input></b-col>
        <!-- <b-col cols="1"> days</b-col> -->
      </b-row>
      <b-row><b-col cols="5"></b-col><b-col cols="5"><b-alert v-if="alertRecurring" variant="info" v-model="alertRecurring" dismissible>Recurring Schedules must have a starting date</b-alert></b-col></b-row>
      <b-row class="mt-2"><b-col><b-alert v-if="alertSched" variant="info" v-model="alertSched" dismissible>Schedule must be set either by day of week or by date. Not both.</b-alert></b-col></b-row>
      <b-row class="mt-2">
        <b-col class="px-md-5"><b-button variant="outline-dark" @click="validateSchedule">Update Schedule</b-button></b-col>
        <b-col class="px-md-5"><b-button variant="outline-danger" style="float:right;" @click="confirmDeleteSchedule">Delete Schedule</b-button></b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row class="mt-2"><b-col style="text-align:center;"><b-button variant="primary" @click="insertSchedule">Add Schedule</b-button></b-col></b-row>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'PLLocations',
  props: ['location', 'productlist'],
  data () {
    return {
      daysofweek: [
        {text: 'Mon', value: 1},
        {text: 'Tue', value: 2},
        {text: 'Wed', value: 3},
        {text: 'Thu', value: 4},
        {text: 'Fri', value: 5},
        {text: 'Sat', value: 6},
        {text: 'Sun', value: 7}
      ],
      alertSched: false,
      alertRecurring: false,
      updSched: {
        activedays: this.activedays,
        date: this.schedDate,
        recurring: this.recurringDays
      }
    }
  },

  computed: {
    activedays: {
      get: function() {
        var dow = [];
        for (const i in this.location.loc_pl_schedule.days) {
          if (this.location.loc_pl_schedule.days[i] == 1) {
              dow.push(Number(i)+1);
          }
        }
        // this.updSched.activedays = dow;
        return dow;
      },
      set: function(newVal) {
        this.updSched.activedays = newVal;
      }
    },

    recurringDays: {
      get: function() {
        // get chosen date, original date, or nothing, in that order
        if (!this.updSched.recurring) {
          if (!this.location.loc_pl_schedule.every_x_days) {
            return '';
          } else {
            return this.location.loc_pl_schedule.every_x_days;
          }
        } else {
          return this.updSched.recurring;
        }
      },
      set: function(newVal) {
        this.updSched.recurring = newVal;
      }
    },

    // empty date passed as null
    schedDate: {
      get: function() {
        // get chosen date, original date, or nothing, in that order
        if (!this.updSched.date) {
          if (!this.location.loc_pl_schedule.date) {
            return '';
          } else {
            return moment.parseZone(this.location.loc_pl_schedule.date).format('YYYY-MM-DD');
          }
        } else {
          return this.updSched.date;
        }
      },
      set: function(newVal) {
        this.updSched.date = newVal;
      }
    },

    convertDOW: function() {
      // set days as checkbox values either original or updated version
      var days = this.updSched.activedays == undefined ? this.activedays : this.updSched.activedays;

      // build list of days based on checkboxes
      var dow = '';
      var i=1;
      while (i<8) {
        if (days.includes(i)) {
          dow+='1';
        } else {
          dow+='0';
        }
        i++;
      }
      return dow;
    },
  },

  methods: {
    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    emitFetchProductLists() {
      this.$emit('emit-fetch-productlists');
    },

    validateSchedule() {
      if (this.updSched.recurring && this.schedDate.length == 0) {
        this.alertRecurring = true;
        return;
      }
      if (this.convertDOW != '0000000' && this.schedDate.length > 0) {
        this.alertSched = true;
        return;
      }
      this.updateSchedule();

    },

    async updateSchedule() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        location_id: this.location.id,
        product_list_id: this.productlist.id,
        days: this.convertDOW
        // date: this.schedDate,
        // every_x_days: this.recurringDays
      }
      if (this.schedDate) {
        body['date'] = this.schedDate;
      }

      if (this.recurringDays) {
        body['every_x_days'] = this.recurringDays;
      }


      // update order with status of 'ready'
      const { data } = await this.$api.patch('schedule/'+this.location.loc_pl_schedule.id,
        body,
        config
      );
      if (data.updated == true) {
        this.emitFetchProductLists();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the schedule, please try again later.', {
          title: 'Error updating schedule',
          centered: true
        })
      }
    },

    async insertSchedule() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "location_id": this.location.id,
        "product_list_id": this.productlist.id
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('productlists/'+this.productlist.id+'/schedule',
        body,
        config
      );
      if (data.created == true) {
        this.emitFetchProductLists();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem adding the schedule, please try again later.', {
          title: 'Error adding schedule',
          centered: true
        })
      }
    },

    confirmDeleteSchedule() {
      // Get a confirmation before deleting
      var confirmDel = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete the schedule!', {
        title: 'Please confirm delete',
        centered: true
      })
      // Confirmed - you can delete the category now!
      .then(value => {
        confirmDel = value
        if (confirmDel == true) {
          this.deleteSchedule();
        }
      })
      // Error processing modal
      .catch(err => {
        console.log('an error has occurred. '+ err)
      })
    },

    async deleteSchedule() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('schedule/'+this.location.loc_pl_schedule.id,
        config
      );
      if (data.deleted == true) {
        this.emitFetchProductLists();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the schedule, please try again later.', {
          title: 'Error deleting schedule',
          centered: true
        })
      }
    },

  },
}
</script>

<style>
</style>
